/*
 * @Date: 2022-07-07 11:16:05
 * @LastEditors: guantingting
 * @LastEditTime: 2024-01-04 15:39:55
 */
import Vue from 'vue'
import Router from 'vue-router'
import test from '@/pages/test/test'
import order from '@/pages/order/order'
import choose from '@/pages/choose/choose'
import vehicle from '@/pages/vehicle/vehicle'
import shop from './pages/shop/shop'
import commonRenter from '@/pages/commonRenter/commonRenter'
import coupon from './pages/coupon/coupon'
import pay from './pages/pay/pay'
import invoice from './pages/invoice/invoice'
import travel from './pages/travel/travel'
import activity from './pages/activity/activity'
import agreement from './pages/agreement/agreement'
import couponOrder from './pages/couponOrder/couponOrder'
import discountMall from './pages/discountMall/discountMall'
import thirdLogin from './pages/thirdLogin/thirdLogin'
import camper from './pages/camper/camper'
import discover from '@/pages/discover/discover'
import travelProduct from './pages/travelProduct/travel'
import customerCenter from './pages/customerServiceCenter/customerCenter'
import secondCar from './pages/secondHandCar/car'
import newCar from './pages/newCar/car'
import login from '@/pages/login/login'
import tool from '@/pages/toolPage/tool'
import vehicleCustody from '@/pages/vehicleCustody/vehicleCustody'
import forapp from '@/pages/forapp/forapp'
import mAboutUs from '@/pages/mAboutUs/mAboutUs'
import equityPackage from '@/pages/equityPackage/equityPackage'
import smsPage from '@/pages/smsPage/smsPage'
import c2c from '@/pages/c2c/c2c'
import comprehensiveCamp from '@/pages/comprehensiveCamp/comprehensiveCamp'
import minRouter from './minRouter'
import repair from '@/pages/repair/repair'
import carBusiness from './pages/carBusiness/carBusiness'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error);
}

Vue.use(Router)

export default new Router({
  mode: 'history',

  // scrollBehavior (to, from , savedPosition) {
  //   return { x: 0, y: 0}
  // },

  // 路由
  routes: [
    {
      path: '/rent/v2',
      name: 'home',
      component: () => import('@/pages/index'),
      meta: { title: '首页', requireAuth: true },
    },
    ...test,
    ...order,
    ...choose,
    ...vehicle,
    ...shop,
    ...commonRenter,
    ...coupon,
    ...pay,
    ...invoice,
    ...travel,
    ...agreement,
    ...couponOrder,
    ...discountMall,
    ...thirdLogin,
    ...camper,
    ...discover,
    ...travelProduct,
    ...customerCenter,
    ...secondCar,
    ...newCar,
    ...login,
    ...tool,
    ...vehicleCustody,
    ...forapp,
    ...mAboutUs,
    ...equityPackage,
    ...smsPage,
    ...c2c,
    ...comprehensiveCamp,
    ...minRouter,
    ...repair,
    ...carBusiness,
    {
      path: '/activity',
      name: 'activity',
      component: () => import('@/pages/activity/index'),
      meta: { title: '活动首页', requireAuth: true },
      children: [
        ...activity
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router.js